import { API_TYPE } from "../../utils/config";

export const SET_GQL_AUTH_LOGIN = {
  ...API_TYPE("SET_GQL_AUTH_LOGIN"),
  RESET: "SET_GQL_AUTH_LOGIN_RESET",
};
export const SET_GQL_REFRESH_TOKEN = API_TYPE("SET_GQL_REFRESH_TOKEN");
export const SET_AUTH_LOGOUT = "SET_AUTH_LOGOUT";
export const SET_GQL_AGENT_CONTACT_DETAILS = API_TYPE(
  "SET_GQL_AGENT_CONTACT_DETAILS"
);
export const SET_GQL_GST_STATE_CODE = API_TYPE("SET_GQL_GST_STATE_CODE");
export const SET_GQL_COUNTRIES_CODE = API_TYPE("SET_GQL_COUNTRIES_CODE");
export const SET_GQL_CITIES_CODE = API_TYPE("SET_GQL_CITIES_CODE");
export const SET_GQL_CURRENCY_LIST = API_TYPE("SET_GQL_CURRENCY_LIST");
export const SET_AUTH_FORGOTPASSWORD = API_TYPE("SET_AUTH_FORGOTPASSWORD");
export const RESET_AUTH_FORGOTPASSWORD = "RESET_AUTH_FORGOTPASSWORD";
export const SET_AUTH_RESETPASSWORD = API_TYPE("SET_AUTH_RESETPASSWORD");
export const RESET_AUTH_RESETPASSWORD = "RESET_AUTH_RESETPASSWORD";
export const GENERATE_ACCESS_TOKEN_DETAILS = API_TYPE(
  "GENERATE_ACCESS_TOKEN_DETAILS"
);
export const SET_AUTH_RESENDOTP = API_TYPE("SET_AUTH_RESENDOTP");
export const SET_AUTH_VERIFYOTP = API_TYPE("SET_AUTH_VERIFYOTP");
export const SET_AUTH_CHANGEPASSWORD = API_TYPE("SET_AUTH_CHANGEPASSWORD");
export const RESET_AUTH_RESENDOTP = "RESET_AUTH_RESENDOTP";
export const RESET_AUTH_VERIFYOTP = "RESET_AUTH_VERIFYOTP";
export const RESET_AUTH_CHANGEPASSWORD = "RESET_AUTH_CHANGEPASSWORD";
export const SET_AUTH_RESETPASSWORDLS = API_TYPE("SET_AUTH_RESETPASSWORDLS");
export const RESET_AUTH_RESETPASSWORDLS = "RESET_AUTH_RESETPASSWORDLS";
